import { Link } from "react-router-dom";
import { Instagram, Music2 } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the inner circle.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#831132] text-[#FFF4E0] mt-32" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif-display text-3xl md:text-4xl leading-tight">
            Join the<br />Hair Bu&apos;tik circle.
          </div>
          <p className="text-[#FFF4E0]/80 mt-4 text-sm max-w-md">
            First access to drops, styling guides and members-only offers. Crown yourself in style.
          </p>
          <form onSubmit={subscribe} className="mt-8 flex items-center gap-3 border-b border-[#FFF4E0]/40 pb-2 max-w-md">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="bg-transparent flex-1 outline-none placeholder:text-[#FFF4E0]/50 text-sm py-2"
              data-testid="newsletter-email"
            />
            <button
              type="submit"
              disabled={loading}
              className="text-[11px] tracking-[0.25em] uppercase font-medium hover:opacity-70"
              data-testid="newsletter-submit"
            >
              {loading ? "..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="overline text-[#C5A059] mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/wigs" className="hover:text-[#C5A059]">Wigs</Link></li>
            <li><Link to="/shop/bundles" className="hover:text-[#C5A059]">Bundles</Link></li>
            <li><Link to="/shop/frontals" className="hover:text-[#C5A059]">Frontals</Link></li>
            <li><Link to="/shop/closures" className="hover:text-[#C5A059]">Closures</Link></li>
            <li><Link to="/shop/hair-care" className="hover:text-[#C5A059]">Hair Care</Link></li>
            <li><Link to="/shop/accessories" className="hover:text-[#C5A059]">Accessories</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline text-[#C5A059] mb-4">House</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#C5A059]" data-testid="footer-about">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#C5A059]" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/faq" className="hover:text-[#C5A059]" data-testid="footer-faq">FAQ</Link></li>
            <li><Link to="/returns" className="hover:text-[#C5A059]" data-testid="footer-returns">Returns</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[#C5A059] mb-4">Follow</div>
          <div className="flex items-center gap-4 mb-6">
            <a href="https://instagram.com/thehairbutik" target="_blank" rel="noreferrer" className="hover:text-[#C5A059]" data-testid="social-instagram" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="https://tiktok.com/@thehairbutik" target="_blank" rel="noreferrer" className="hover:text-[#C5A059]" data-testid="social-tiktok" aria-label="TikTok"><Music2 size={20} /></a>
          </div>
          <p className="text-xs text-[#FFF4E0]/70 leading-relaxed">
            Hair Bu&apos;tik Limited<br />
            5 Bradford Square, London E1 0SG, England<br />
            Company No. 17222084
          </p>
        </div>
      </div>
      <div className="border-t border-[#FFF4E0]/20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-[#FFF4E0]/70">
          <div>© {new Date().getFullYear()} The Hair Bu&apos;tik. Crown Yourself.</div>
          <div>Established 2026 · United Kingdom</div>
        </div>
      </div>
    </footer>
  );
}
